import { Injectable } from '@angular/core';
import { ObjectHelper } from '@barthauer/abc/core';
import { Query, QueryColumn, QueryObjectsModel } from '@barthauer/abc/core/data';
import { ParameterValue } from '@barthauer/abc/queries/parameters/core';
import { LayoutViewModel, SubLayoutViewModel } from '../viewModels/layout.viewModel';
import { LayoutReferenceInfo, LayoutReferencesInfo } from './higon.model';

@Injectable({
  providedIn: 'root',
})
export class HigonService {
  public pdc = ['Property', 'Document', 'Comment'];

  constructor() {}

  public createSpecialTypeQuery(
    layoutViewModel: LayoutViewModel,
    id: string,
    opath: string,
    defaultLayoutReferenceIdExpression: string,
    layoutReferenceIdExpression: string
  ): QueryObjectsModel {
    const queryDocument: QueryObjectsModel = new QueryObjectsModel();
    const higonGridObjectsQuery: Query = new Query();
    const specialTypeColumn: QueryColumn = new QueryColumn();
    const subQuery: Query = new Query();
    const subQueryColumns: QueryColumn = new QueryColumn();
    const _opath = 'Type(' + layoutViewModel.objectType + ")[Id='" + id + "']";
    higonGridObjectsQuery.LimitCount = 1;
    higonGridObjectsQuery.ObjectType = layoutViewModel.objectType;
    higonGridObjectsQuery.OPath = _opath;
    specialTypeColumn.Name = ObjectHelper.nameof<LayoutReferencesInfo>('defaultLayoutReferenceId');
    specialTypeColumn.OPath = defaultLayoutReferenceIdExpression;
    higonGridObjectsQuery.Columns = [specialTypeColumn];
    queryDocument.ObjectQueries = [higonGridObjectsQuery];
    subQuery.Name = ObjectHelper.nameof<LayoutReferencesInfo>('layoutReferences');
    subQuery.OPath = opath;
    subQueryColumns.Name = ObjectHelper.nameof<LayoutReferenceInfo>('layoutReferenceId');
    subQueryColumns.OPath = layoutReferenceIdExpression;
    subQuery.Columns = [subQueryColumns];
    higonGridObjectsQuery.ObjectQueries = [subQuery];
    return queryDocument;
  }

  public createHigonQuery(
    layoutViewModel: LayoutViewModel,
    higonTabs: SubLayoutViewModel[],
    parameters: ParameterValue[]
  ): QueryObjectsModel {
    const queryDocument: QueryObjectsModel = new QueryObjectsModel();
    queryDocument.Parameters = parameters;
    const higonGridObjectsQuery: Query = new Query();
    higonGridObjectsQuery.LimitCount = 1;
    higonGridObjectsQuery.OPath = 'Type(' + layoutViewModel.objectType + ')[Id=$Id]';
    higonGridObjectsQuery.Columns = this.prepareHigonColumns(layoutViewModel.objectType, higonTabs);
    queryDocument.ObjectQueries = [higonGridObjectsQuery];
    return queryDocument;
  }

  private prepareHigonColumns(objectType: string, higonTabs: SubLayoutViewModel[]): QueryColumn[] {
    const higonColumns: QueryColumn[] = [];
    for (let i = 0; i < higonTabs.length; i++) {
      const tab = higonTabs[i];
      higonColumns.push({
        Name: 'T' + i,
        OPath: 'Count(' + tab.opath + ')',
      });
    }
    if (this.pdc.indexOf(objectType) === -1) {
      higonColumns.push(
        {
          Name: 'Properties',
          OPath: 'Count(Properties[ParentId=^.Id And Not(IsNull(TextValue))])',
        },
        {
          Name: 'Documents',
          OPath: 'Count(Documents[ParentId=^.Id])',
        },
        {
          Name: 'Comments',
          OPath: 'Count(Comments[ParentId=^.Id And (Not(IsNull(Text)) Or Not(IsNull(Comment)))])',
        }
      );
    }
    higonColumns.push(
      {
        Name: 'InsertOn',
        OPath: 'SysDateInsert',
      },
      {
        Name: 'InsertAt',
        OPath: 'SysTimeInsert',
      },
      {
        Name: 'InsertBy',
        OPath: 'SysUserNameInsert',
      },
      {
        Name: 'UpdateOn',
        OPath: 'SysDateUpdate',
      },
      {
        Name: 'UpdateAt',
        OPath: 'SysTimeUpdate',
      },
      {
        Name: 'UpdateBy',
        OPath: 'SysUserNameUpdate',
      }
    );
    return higonColumns;
  }
}
